import React, { useState } from "react";
import "../7ALoading/sevenA.css";

import PunctualityNavbar from "./PunctualityNavbar";
import PunctualitySummary from "./PunctualitySummary";
import PunctualityMaster from "./PunctualityMaster";
import PunctualityPerformanceMaster from "./PunctualityPerformance/PunctualityPerformanceMaster";

const PunctualityNavMaster = () => {
  const [filteredAF, setFilteredAF] = useState(null);
  const [aFData, setAFData] = useState(null);
  const [openStates, setOpenStates] = useState({
    Year: "",
    "Asset Group": "",
    "Main Cause": "",
    "Sub Cause": "",
    Month: "",
    "Line Up Down": "",
    Shift: "",
    Section: "",
    "Block Station": "",
  });
  const [treeMapPath, setTreeMapPath] = useState({
    F_YEAR: "",
    ASSET_GROUP: "",
    MAIN_CAUSE_DESC: "",
    SUB_CAUSE_DESC: "",
    Month: "",
  });
  const [activePage, setActivePage] = useState("Overview");

  return (
    <div>
      <div className="sticky-controller">
        {/* <AFController
          openStates={openStates}
          setFilteredAF={setFilteredAF}
          setOpenStates={setOpenStates}
          setAFData={setAFData}
        /> */}
      </div>
      {/* ////////////////////////////////////////////////////////////////////////////////////////// */}
      <div>
        <PunctualityNavbar
          activePage={activePage}
          setActivePage={setActivePage}
        />
      </div>
      <div
        style={{ minHeight: "90vh" }}
        onClick={() => {
          setOpenStates({
            Year: false,
            "Asset Group": false,
            "Main Cause": false,
            "Sub Cause": false,
            Month: false,
            "Line Up Down": false,
            Shift: false,
            Section: false,
            "Block Station": false,
          });
        }}
      >
        {activePage === "Asset remark" && (
          <div className="fade-in-up">
            <div className="row m-1">
              <div className="col-md">
                {/* <AssetMap data={filteredAF} setTreeMapPath={setTreeMapPath} /> */}
              </div>
              {/* {  filteredAF.length >= 2 && (
            <div className="col-md">
              <AssetMap data={filteredAF} second={true} />
            </div>
          )} */}
            </div>{" "}
            <div className="row m-1">
              <div className="col-md-2 ">
                <div className="newUiBody" style={{ height: "100%" }}>
                  {/* <DataSummary
                    data={filteredAF}
                    fy={  filteredAF[0]?.F_YEAR}
                  /> */}
                </div>
              </div>
              <div className="col-md-10 ">
                {/* <AssetRemark data={filteredAF} path={treeMapPath} /> */}
              </div>
            </div>
          </div>
        )}
        {activePage === "Overview" && (
          <div className="fade-in-up">
            {" "}
            <PunctualityMaster />
          </div>
        )}
        {activePage === "Summary" && (
          <div className="fade-in-up">
            {" "}
            <PunctualitySummary />
          </div>
        )}
        {activePage === "Punctuality performance" && (
          <div className="fade-in-up">
            {" "}
            <PunctualityPerformanceMaster />
          </div>
        )}
      </div>{" "}
    </div>
  );
};
export default PunctualityNavMaster;
